module.exports = __webpack_public_path__ + "img/41.bfd4ec43.jpg";